import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import { Table, Form } from 'react-bootstrap';
import { withRouter} from 'react-router-dom';

import DeckGL from '@deck.gl/react';
import {PolygonLayer} from '@deck.gl/layers';

import {StaticMap, MapContext, NavigationControl} from 'react-map-gl';
import {MapboxLayer} from '@deck.gl/mapbox';

import NavbarMenu from './NavbarMenu/NavbarMenu';

import LotTabs from './LotTabs/LotTabs';

import LotForm from './LotForm/LotForm';
import ReservationForm from './ReservatinForm/ReservationForm';
import Log from './Log/Log';
import mixin from '../../utils/mixin';
import consts from "../../utils/constants";

import { 
  getDevelopmentByCode,
  getSettingsStatus,
  getLotsByDevelopment,
  deleteLot,
  getTowersByDevelopment,
  getStoriesByDevelopment,
  getSeparatorsByDevelopment,
} from '../../api/Api.js';

import './Admin.scss';

const {methods} = mixin;

const MAPBOX_TOKEN = process.env.REACT_APP_MAP_BOX_TOKEN;
const DEVELOPMENT_CODE = process.env.REACT_APP_DEVELOPMENT_CODE;

const NAV_CONTROL_STYLE = {
  position: 'absolute',
  top: 10,
  left: 10
};

const MAX_PITCH = 90;
const INITIAL_PITCH = 45;

class Admin extends Component {

  constructor(props){
    
    super(props);

    this.validateLogin();

    methods.G_changeLanguage('es');

    this.tooltipRef = React.createRef();

    this.state = {
      hoverInfo : null,
      gl: null,
      isHovering: false,
      loading: false,
      lots: [],
      towers: [],
      stories: [],
      separators: [],
      selected_lot: null,
      action: null,
      development: null,
      development_id: null,
      status_array: [],
      show2D: false,
      showSatelliteMap: false,
      polygonExtruded: true,
      deckGLPitch: INITIAL_PITCH,
      deckGLInitialState: {
        longitude: -99.13293143846279,
        latitude: 19.43276303911265,
        zoom: 5,
        maxZoom: 20,
        minZoom: 5,
        pitch: INITIAL_PITCH,
        bearing: 0,
        maxPitch: MAX_PITCH,
        minPitch: 0
      }
    }
  }

  validateLogin = () => {
    let token = localStorage.getItem('jwt');

    if(token){
      const decoded = jwt_decode(token);
      let date = new Date(decoded.exp * 1000);
      let mydate = new Date();
      
      if (date <= mydate) {
        this.logout();
      }
    }else{
      this.logout();
    }
  }

  logout = () => {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    localStorage.removeItem("developments");
    this.props.history.push("/admin/login");
    window.location.reload();
  }

  addLot = () => {
    this.validateLogin();

    this.setState({
      action: 'add',
      selected_lot: null
    })
  }

  editLot = (lot) => {
    this.validateLogin();
    if (lot != null && lot != undefined) {
      this.setState({
        action: 'tabs',
        selected_lot: lot
      })
    }
  }

  delete = (lot) => {
    if(window.confirm('¿Estás seguro que deseas eliminar el lote ' + lot.name + '?') == true){
      let id = lot['_id'];
      if(id){
        deleteLot(id).then(
          (res) => {
            if(res && res['_id']){
              let index = this.state.lots.findIndex((item) =>lot['_id'] == item['_id']);
              let lots = [...this.state.lots]
              if(index >= 0){
                lots.splice(index, 1)
                this.setState({
                  lots: lots
                });
              }
            }else{
              // TODO: Mostrar mensaje
            }
          }
        );
      }
    }
  }

  updateDeletedLot = (lot_id) => {
    let index = this.state.lots.findIndex((item) => lot_id == item['_id']);
    let lots = [...this.state.lots]
    if(index >= 0){

      if(this.state.development && this.state.development.is_vertical){
        this.updateStoryHeight(lots[index], 0);
      }

      lots.splice(index, 1);

      this.enableAllLots();
      let separators = this.getSeparators(lots);

      this.setState({
        lots: lots,
        action: null,
        selected_lot: null,
        separators: separators,
      });
    }
  }

  viewReservationLot = (lot) => {
    this.setState({
      action: 'view_reservation',
      selected_lot: lot
    })
  }

  reserveLot = (lot) => {
    this.setState({
      action: 'reserve',
      selected_lot: lot
    })
  }

  showLogLot = (lot) => {
    this.setState({
      action: 'log',
      selected_lot: lot
    })
  }

  showLotsList = () => {
    this.validateLogin();
    this.enableAllLots();
    this.setState({
      action: null,
      selected_lot: null
    })
  }

  // DeckGL and mapbox will both draw into this WebGL context
  _onWebGLInitialized = (gl) => {
    this.setState({gl});
  }

  // Add deck layer to mapbox
  _onMapLoad = () => {
    const map = this._map;
    const deck = this._deck;
    map.addLayer(new MapboxLayer({id: 'my-scatterplot', deck}));
  }
  
  getPolygon(p){
    let c = p.coordinates.latlon;
    let res = [];
    c.forEach(i => {
      let lonlat = [i[1], i[0], this.getHeightOffset(p)];
      res.push(lonlat);
    });
    return [res]
  }

  getElevation(p){
    return parseFloat(p.height);
  }

  getFillColor(p){
    let status =  this.state.status_array ? this.state.status_array.find(x => x.key == p.status) : null;
    
    if(status){
      return [status.red,status.green,status.blue];
    }
    
    return [108,117,125];
    
  }

  onClick(info, event){
    this.hideUpperStories(info);
    this.editLot(info.object);
  }

  onHover = (info) =>{
    this.setState({
      hoverInfo: info
    });
  }

  onDeckHover = (object) => {
    if(object.object && object.object.name){
      this.setState({
        isHovering: true
      });
    }else{
      this.setState({
        isHovering: false
      });
    }
  }

  getCursor = (action) => {
    const { hoverInfo, gl, isHovering } = this.state;
    
    if(isHovering){
      return 'pointer';
    }

    return action.isDragging ? 'grabbing' : 'grab';
  }

  getMetadata = (k, v) => {
    let label = '';
    let sufix = '';
    switch(k){
      case 'FRONT': label = 'Frente'; sufix = ' m'; break; 
      case 'DEPTH': label = 'Fondo'; sufix = ' m'; break;
      case 'AREA': label = 'Área'; sufix = ' m2'; break;
    }

    if(label != ''){
      return (
        <span key={k}>{label}: <b>{v} {sufix}</b><br/></span>
      )
    }
    return (
      <span key={k}></span>
    )
  }

  renderPrice = (object) => {
    if(object.price){
      if(object.discount && object.discount > 0){
        return(
          <p className="text-right">
            Reserva con: <b>{methods.G_renderPrice(object.price, 'MXN')}</b><br/>
            Descuento: <b>-{methods.G_renderPrice(object.discount,'MXN')}</b><br/>
            Final: <b>{methods.G_renderPrice(object.price - object.discount, 'MXN')} </b><br/>
          </p>
        )
      }else{
        return(
          <p>Reserva con: <b>{methods.G_renderPrice(object.price, 'MXN')}</b></p>
        )
      }
    }
  }

  renderSimplePriceAmount = (price) => {
    if(price){
      return(
        methods.G_renderPrice(price, 'MXN')
      )
    }
    return(
      '-'
    )
  }

  renderMetadata = (object) => {
    
    if(object.metadata && object.metadata.length > 0){
      let meta = [];
      for(let j = 0; j < object.metadata.length; j++){
        for (const [key, value] of Object.entries(object.metadata[j])) {
          meta[key] = value;
        }
      }

      let front = meta['FRONT'] ? meta['FRONT'] : null;
      let depth = meta['DEPTH'] ? meta['DEPTH'] : null;
      let area = meta['AREA'] ? meta['AREA'] : null;
      let price_m2 = meta['PRICE_M2'] ? meta['PRICE_M2'] : null;
      let lot_price = null;
      if(area != '-' && price_m2 != null){
        lot_price = parseFloat(area) * parseFloat(price_m2);
        lot_price = lot_price.toFixed(2);
      }

      return (
        <span>
          <p>
            { front && 
              <span>Frente: <b>{front} m</b><br/></span>
            }
            { depth &&
              <span>Fondo: <b>{depth} m</b><br/></span>
            }
            { area && 
              <span>Área: <b>{area} m2</b><br/></span>
            }
            { price_m2 && 
              <span>Precio (m2): <b>{this.renderSimplePriceAmount(price_m2)}</b><br/></span>
            }
            { lot_price && 
              <span>Precio Lote: <b>{this.renderSimplePriceAmount(lot_price)}</b><br/></span>
            }
          </p>
          {this.renderPrice(object)}
        </span>
      );
    }

    return (
        <span>
          {this.renderPrice(object)}
        </span>
      );
  }

  getSeparatorPolygon(p){
    let c = p.coordinates.latlon;
    let res = [];
    c.forEach(i => {
      let lonlat = [i[1], i[0], this.getSeparatorHeightOffset(p)];
      res.push(lonlat);
    });
    return [res]
  }

  getHeightOffset(p){
    if(this.state.development && this.state.development.is_vertical){
      if(p.story_number && p.story_number > 1){
        let stories_below = this.state.stories.filter(x => (x.tower_id == p.tower_id && x.number < p.story_number));
        if(stories_below.length > 0){
          let count_separators = stories_below.length;
          let offset = 0;
          stories_below.forEach(i => {
            offset += i.height;
          });
          return offset + (count_separators * 0.1);
        }
      }
    }

    return 0;
  }

  getSeparatorHeightOffset(p){
    if(this.state.development && this.state.development.is_vertical){
      if(p.story_number && p.story_number > 1){
        let stories_below = this.state.stories.filter(x => (x.tower_id == p.tower_id && x.number < p.story_number));
        if(stories_below.length > 0){
          let count_separators = stories_below.length - 1;
          let offset = 0;
          stories_below.forEach(i => {
            offset += i.height;
          });
          return offset + (count_separators * 0.1);
        }
      }
    }

    return 0;
  }

  hideUpperStories(p){
    let lot = p && p.object ? p.object : null;

    if(this.state.development && this.state.development.is_vertical && lot){
      
      this.state.lots.map((x) => {
        x.enabled = true;
        if(x.tower_id == lot.tower_id && x.story_number > lot.story_number){
          x.enabled = false;
        }
      });

      this.state.separators.map((x) => {
        x.enabled = true;
        if(x.tower_id == lot.tower_id && x.story_number > lot.story_number){
          x.enabled = false;
        }
      });

    }

  }

  enableAllLots(){
    this.state.lots.map((x) => {
      x.enabled = true;
    });
    this.state.separators.map((x) => {
      x.enabled = true;
    });
  }

  getVisibleLots(){
    return this.state.lots.filter(x => x.enabled);
  }

  getVisibleSeparators(){
    return this.state.separators.filter(x => x.enabled);
  }

  getSeparators(lots){
    let separators = lots.map((x) => {
      return {
        height: 0.1,
        tower_id: x.tower_id,
        story_id: x.story_id,
        story_number: x.story_number,
        coordinates: x.coordinates,
        enabled: x.enabled,
      }
    })

    return separators;
  }

  updateStoryHeight(lot, action){
    console.log('updateStoryHeight action', action)
    let story_id = lot['story_id'];
    let lots = this.state.lots.filter(x => x.story_id == story_id);
    console.log('updateStoryHeight lots', lots)
    let current_height = action == 1 ? parseFloat(lot['height']) : 0.0;
    lots.forEach(i => {
      if(action == 0 && i['_id'] == lot['_id']){
        return false;
      }
      let lot_height = (action == 2 && i['_id'] == lot['_id']) ? parseFloat(lot['height']) : parseFloat(i['height']);
      console.log('updateStoryHeight comp', lot_height, current_height)
      if(lot_height > current_height){
        current_height = lot_height;
      }
    });

    console.log('updateStoryHeight current_height', current_height)

    if(current_height > 0){
      let index = this.state.stories.findIndex((item) =>item['_id'] == story_id);
      let stories = [...this.state.stories]

      console.log('updateStoryHeight index', index)
      if(index >= 0){
        stories[index] = {...stories[index], ...{height: current_height}};
        console.log('updateStoryHeight stories[index]', stories[index])
        this.setState({
          stories: stories
        });
      }
    }
  }

  dispatchLots = () => new Promise((resolve, reject) => {
    getTowersByDevelopment({
      development_id: this.state.development_id
    }).then((res) => {
      let towers = [];
      if (res) {
          towers = res;
      }
      getStoriesByDevelopment({
        development_id: this.state.development_id
      }).then((res) => {
        let stories = [];
        if (res) {
            stories = res;
        }
        
        getLotsByDevelopment({
          development_id: this.state.development_id
        }).then((res) => {
          let lots = [];
          if (res) {
            let state_lots = this.state.lots;
            lots = res.map((i) => {
              let current = state_lots.find(x => x._id == i._id);
              let is_enabled = current ? current.enabled : true;
              return {...i, ...{enabled: is_enabled}}
            });
          }

          let separators = this.getSeparators(lots);
          
          this.setState({
            lots: lots ,
            towers: towers,
            stories: stories,
            separators: separators,
          }, () => resolve('lots data ok'));
        });
        
      });
    });
  });

  addNewLot = (lot) => {
    let lots = [...this.state.lots, {...lot, ...{enabled: true}}]

    if(this.state.development && this.state.development.is_vertical){
      this.updateStoryHeight(lot, 1);
    }

    this.enableAllLots();
    let separators = this.getSeparators(lots);
    this.setState({
      lots: lots,
      separators: separators,
    });
  }

  updateLot = (lot) => {
    let index = this.state.lots.findIndex((item) =>lot['_id'] == item['_id']);
    let lots = [...this.state.lots]
    if(index >= 0){
      lot.enabled = true;
      lots[index] = lot;

      if(this.state.development && this.state.development.is_vertical){
        this.updateStoryHeight(lots[index], 2);
      }

      this.enableAllLots();
      let separators = this.getSeparators(lots);
      this.setState({
        lots: lots,
        separators: separators,
      });
    }
  }

  componentDidMount() {
    this.setState({
      loading: true
    });
    getDevelopmentByCode(DEVELOPMENT_CODE).then(
      (res) => {

        localStorage.setItem("dev", JSON.stringify(res));
        
        this.setState({
          loading: true,
          development_id: res.development_id,
          development: res,
          deckGLInitialState: {
            longitude: res.longitude,
            latitude: res.latitude,
            zoom: res.zoom,
            maxZoom: res.max_zoom,
            minZoom: res.min_zoom,
            pitch: INITIAL_PITCH,
            bearing: 0,
            maxPitch: MAX_PITCH,
            minPitch: 0
          }
        }, () => {
          Promise.all([this.dispatchLots()]).then(values => {
            
            this.setState({
                loading: false,
            });
    
          }, reason => {
              console.info(reason)
          });
        });
    
        this._timer = null;
        clearInterval(this._timer);
        this.startTimer();

      }
    );
    
    getSettingsStatus().then(
      (res) => {
        this.setState({
          status_array: res,
        });
      }
    );

  }

  componentWillUnmount() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }

  startTimer() {
    var self = this;
    setTimeout(function () {
      self.redo();
      self._timer = setInterval(self.redo.bind(self), 30000);
    }, 500);
  }

  redo() {
    this.refresh();
  }
  
  refresh = () => {
    this.dispatchLots();
  }

  renderSimplePrice = (object) => {
    if(object.price){
      if(object.discount && object.discount > 0){
        let total = object.price - object.discount;
        return(
          <span>{methods.G_renderPrice(total, 'MXN')} *</span>
        )
      }
      return(
        <span>{methods.G_renderPrice(object.price, 'MXN')} </span>
      )
    }
    return(
      <span>-</span>
    )
  }

  renderStatusLabel = (object) => {
    let status =  this.state.status_array ? this.state.status_array.find(x => x.key == object.status) : null;
    let label = status ? status.label : '-';

    if(object.status == 'SOLD' && object.hasOwnProperty('confirmed') && object.confirmed === false){
      label = 'Apartado en Proceso';
    }

    let color = this.getFillColor(object);
    color = 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')';

    return (
      //<span style={{backgroundColor: color, color:'white', fontSize:'12px', padding:'3px', borderRadius:'5px'}}>{label}</span>
      <div className="status-label">
        <span className="status-indicator" style={{backgroundColor: color}}></span> <span>{label}</span>
      </div>
    )
  }

  renderReservationBtn = (i) => {
    if(i.status == 'SOLD'){
      return (
        <span className="action-link mr-3" onClick={this.viewReservationLot.bind(this, i)}>Ver Reservación</span>
      )  
    }
    return (
      <span className="action-link mr-3" onClick={this.reserveLot.bind(this, i)}>Reservar</span>
    )
  }

  renderEditLotBtn = (i) => {
    if(i.status != 'SOLD'){
      return (
        <span className="action-link mr-3" onClick={this.editLot.bind(this, i)}>Editar</span>
      );
    }
  }

  renderDeleteLotBtn = (i) => {
    if(i.status != 'SOLD'){
      return (
        <span className="action-link mr-3" onClick={this.delete.bind(this, i)}>Eliminar</span>
      );
    }
  }
  
  renderLotsTable = () => {
    let lots = (this.state.lots && this.state.lots.length > 0) ? [...this.state.lots] : [];
    let dev = this.state.development;

    lots.sort(function (a, b) {
      if(dev.is_vertical){
        var aTower = a.tower_number;
        var bTower = b.tower_number;
        var aStory = a.story_number;
        var bStory = b.story_number;
        var aBlock = a.block;
        var bBlock = b.block;
        var aNumber = a.number;
        var bNumber = b.number;
        
        if(aTower == bTower){
          if(aStory == bStory){
            if(aBlock == bBlock){
                return (aNumber < bNumber) ? -1 : (aNumber > bNumber) ? 1 : 0;
            }else{
                return (aBlock < bBlock) ? -1 : 1;
            }
          }else{
              return (aStory < bStory) ? -1 : 1;
          }
        }else{
          return (aTower < bTower) ? -1 : 1;
        }
      }else{
        var aBlock = a.block;
        var bBlock = b.block;
        var aNumber = a.number;
        var bNumber = b.number;
        
        
        if(aBlock == bBlock){
            return (aNumber < bNumber) ? -1 : (aNumber > bNumber) ? 1 : 0;
        }else{
            return (aBlock < bBlock) ? -1 : 1;
        }
      }
    });

    const listLots = lots ? lots.map((i) => {
      const { development } = this.state;

      let info = development && development.is_vertical ? i.story_number : i.block;
      return( 
        <tr className="lot-item" onClick={this.editLot.bind(this, i)} key={i._id}>
          <td className="lot_name">{i.name}</td>
          <td className="lot_info pr-1">{this.renderStatusLabel(i)}</td>
          <td className="lot_info d-none d-sm-table-cell pl-1 pr-1" style={{textAlign: 'center'}}><span className="value">{info}</span></td>
          <td className="lot_info d-none d-sm-table-cell pl-1 pr-1" style={{textAlign: 'center'}}><span className="value">{i.number}</span></td>
          <td className="lot_info" style={{textAlign: 'center'}}><span className="value">{this.renderSimplePrice(i)}</span></td>
          
        </tr>
      )
    }) : [];

    if(listLots.length > 0){
      return (
        <Table striped hover>
          <thead>
            <tr>
              <th className="sticky-th">Nombre</th>
              <th className="sticky-th pr-1">Estatus</th>
              { this.state.development && this.state.development.is_vertical &&
                <th className="sticky-th d-none d-sm-table-cell pl-1 pr-1" style={{textAlign: 'center'}}>Piso</th>
              }
              { this.state.development && !this.state.development.is_vertical &&
                <th className="sticky-th d-none d-sm-table-cell pl-1 pr-1" style={{textAlign: 'center'}}>Mza.</th>
              }
              <th className="sticky-th d-none d-sm-table-cell pl-1 pr-1" style={{textAlign: 'center'}}>Núm.</th>
              <th className="sticky-th" style={{textAlign: 'center'}}>Reserva con</th>
            </tr>
          </thead>
          <tbody>
            {listLots}
          </tbody>
        </Table>
      );
    }else{
      return (
        <span>No hay ningún lote configurado.</span>
      );
    }

  }

  getDeckGLState = () => {
    return this.state.deckGLInitialState;
  }

  showMap3D = () => {
    if(this.state.show2D){
      let deckState = {...this.state.deckGLInitialState, ...{pitch: INITIAL_PITCH, maxPitch: MAX_PITCH}};
      
      this.setState({
        show2D: false,
        polygonExtruded: true,
        deckGLInitialState: deckState
      })
    }else{
      let deckState = {...this.state.deckGLInitialState, ...{pitch: 0, maxPitch: 0}};
      
      this.setState({
        show2D: true,
        polygonExtruded: false,
        deckGLInitialState: deckState
      })
    }
  }

  showSatelliteMap = () => {
    this.setState({
      showSatelliteMap: !this.state.showSatelliteMap
    });
  }

  getMapViewStyle = () => {
    if(this.state.showSatelliteMap){
      return "mapbox://styles/mapbox/satellite-streets-v11";
    }
    return "mapbox://styles/mapbox/outdoors-v11";
  }

  getTootltipStyle = (hoverInfo) => {
    
    let tooltipW = 200;
    let tooltipH = 0;
    if(this.tooltipRef.current){
      tooltipW = this.tooltipRef.current.offsetWidth;
      tooltipH = this.tooltipRef.current.offsetHeight;

      let x_val = hoverInfo.x < this._deck.canvas.width / 2 ? hoverInfo.x + 10 : hoverInfo.x - tooltipW - 10;
      let y_val = hoverInfo.y < this._deck.canvas.height / 2 ? hoverInfo.y + 10 : hoverInfo.y - tooltipH - 10;

      return {pointerEvents: 'none', left: x_val, top: y_val};

    }

    return {pointerEvents: 'none', left: 0, top: 0}
    
  }

  usesUTM = () => {
    if(this.state.development && this.state.development.uses_coordinates && this.state.development.uses_coordinates == 1){
      return true;
    }
    return false;
  }
  
  render() {
      const { hoverInfo, gl, lots, loading } = this.state;

      if (loading) {
        return (
          <div className="h-100">
            <NavbarMenu development={this.state.development} logout={this.logout} />
            <div className="container-fluid pt-4 h-100">
              Cargando...
            </div>
          </div>
        );
      }

      return (
        <div className="h-100">
          <NavbarMenu development={this.state.development} logout={this.logout} />
          <div className="container-fluid h-100 ext-container">
            <div className="row h-100">
              <div className="col-12 col-md-5 col-lg-5 col-xl-4 pt-4 pb-4 deckgl-container order-2 order-md-1">
                {
                  this.state.action == null &&
                  this.state.selected_lot == null &&
                  <div>
                    <h3>Lotes</h3>
                    {
                      methods.G_canDo(consts.Security.Action.CREATE_LOT, localStorage.getItem('user')) && 
                      <button className="btn btn-cust-blue btn-add-lot" onClick={this.addLot.bind(this)}>Agregar Lote</button>
                    }
                    <br/><br/>
                    {this.renderLotsTable()}
                  </div>
                }
                {
                  this.state.action == 'tabs' &&
                  this.state.selected_lot != null &&
                  < LotTabs action={this.state.action} vertical={{towers:this.state.towers, stories:this.state.stories}} close={this.showLotsList} lot={this.state.selected_lot} lot_id={this.state.selected_lot['_id']} utm={this.usesUTM()} development={this.state.development} development_id={this.state.development_id} update={this.updateLot} reserve={this.reserveLot} view_reservation={this.viewReservationLot} update_deleted={this.updateDeletedLot} status_array={this.state.status_array} />
                }
                {
                  this.state.action == 'add' &&
                  this.state.selected_lot == null &&
                  < LotForm action={this.state.action} vertical={{towers:this.state.towers, stories:this.state.stories}} close={this.showLotsList} lot={null} lot_id="" utm={this.usesUTM()} development={this.state.development} development_id={this.state.development_id} add={this.addNewLot} status_array={this.state.status_array} />
                }
                {
                  this.state.action == 'update' &&
                  this.state.selected_lot != null &&
                  < LotForm action={this.state.action} close={this.showLotsList} lot={this.state.selected_lot} lot_id={this.state.selected_lot['_id']} utm={this.usesUTM()} development_id={this.state.development_id} update={this.updateLot} reserve={this.reserveLot} view_reservation={this.viewReservationLot} status_array={this.state.status_array} />
                }
                {
                  this.state.action == 'log' &&
                  this.state.selected_lot != null &&
                  < Log action={this.state.action} close={this.showLotsList} lot={this.state.selected_lot} lot_id={this.state.selected_lot['_id']} />
                }
                {
                  this.state.action == 'reserve' &&
                  this.state.selected_lot != null &&
                  < ReservationForm action={this.state.action} close={this.showLotsList} development={this.state.development} lot={this.state.selected_lot} lot_id={this.state.selected_lot['_id']} update={this.updateLot} status_array={this.state.status_array} />
                }
                {
                  this.state.action == 'view_reservation' &&
                  this.state.selected_lot != null &&
                  < ReservationForm action={this.state.action} close={this.showLotsList} development={this.state.development} lot={this.state.selected_lot} lot_id={this.state.selected_lot['_id']} update={this.updateLot} status_array={this.state.status_array} />
                }
              </div>
              <div className="col-12 col-md-7 col-lg-7 col-xl-8 deckgl-container map-container order-1 order-md-2">
                <div className="switch-3D">
                  
                    <Form.Check 
                      type="switch"
                      id="map-view-switch"
                      label="3D"
                      checked={!this.state.show2D}
                      onChange={this.showMap3D}
                    />

                    <Form.Check 
                      type="switch"
                      id="map-view-switch-2"
                      label="Satélite"
                      checked={this.state.showSatelliteMap}
                      onChange={this.showSatelliteMap}
                    />
                  
                </div>
                <DeckGL
                  ref = {ref => {this._deck = ref && ref.deck; }}
                  initialViewState={this.getDeckGLState()}
                  controller={true}
                  onWebGLInitialized={this._onWebGLInitialized}
                  onHover= {object => this.onDeckHover(object)}
                  getCursor= {action => this.getCursor(action)}
                  ContextProvider={MapContext.Provider}
                >
                  <PolygonLayer 
                    id="polygon-layer"
                    data={this.getVisibleLots()} 
                    pickable= {true}
                    stroked= {true}
                    filled= {true}
                    wireframe= {true}
                    extruded= {this.state.polygonExtruded}
                    lineJointRounded= {true}
                    getPolygon= {d => this.getPolygon(d)}
                    getElevation= {d => this.getElevation(d)}
                    getFillColor= {d => this.getFillColor(d)}
                    getLineColor= {[0, 0, 0]}
                    getLineWidth= {1}
                    onClick= {(info, event) => this.onClick(info, event)}
                    onHover={info => this.onHover(info)}
                    material= {{
                      ambient: 0.5,
                      diffuse: 0.6,
                      shininess: 10,
                      specularColor: [30, 30, 30]
                    }}
                  />

                  {this.state.development && this.state.development.is_vertical &&
                    <PolygonLayer 
                      id="separator-layer"
                      data={this.getVisibleSeparators()} 
                      pickable= {true}
                      stroked= {true}
                      filled= {true}
                      wireframe= {true}
                      extruded= {this.state.polygonExtruded}
                      lineJointRounded= {true}
                      getPolygon= {d => this.getSeparatorPolygon(d)}
                      getElevation= {d => this.getElevation(d)}
                      getFillColor= {[0, 0, 0]}
                      getLineColor= {[0, 0, 0]}
                      getLineWidth= {1}
                      material= {{
                        ambient: 0.5,
                        diffuse: 0.6,
                        shininess: 10,
                        specularColor: [30, 30, 30]
                      }}
                    />
                  }
                  
                  {gl && (
                    <StaticMap
                      ref={ref => { this._map = ref && ref.getMap(); }}
                      gl={gl}
                      mapStyle={this.getMapViewStyle()} // mapbox://styles/mapbox/streets-v11, mapbox://styles/mapbox/outdoors-v11, mapbox://styles/mapbox/dark-v10, mapbox://styles/mapbox/satellite-v9
                      mapboxApiAccessToken={MAPBOX_TOKEN}
                      onLoad={this._onMapLoad}
                    />
                  )}
                  {gl && 
                    <NavigationControl style={NAV_CONTROL_STYLE} showCompass={false} />
                  }
                  
                  {hoverInfo && hoverInfo.object && (
                    <div ref={this.tooltipRef} id="tooltip" style={this.getTootltipStyle(hoverInfo)}>
                      <h5>{ hoverInfo.object.name }</h5>
                      {this.renderStatusLabel(hoverInfo.object)}
                      {this.renderMetadata(hoverInfo.object)}
                    </div>
                  )}
                </DeckGL>
              </div>
            </div>
            
          </div>
        </div>
      );
  }

}

export default withRouter(Admin);
